import React from "react";

function About() {
    return (
        <section id="about" className="content-section">
            <div className="content entire-paragraph">
                <h2>About Us</h2>
                <img src="/t1.jpg" width={"auto"} height={300} alt="" style={{margin: 5}}/>
                <img src="/atAmazonOfficeOne.jpeg" width={"auto"} height={300} alt="At the AWS office"
                     style={{margin: 5}}/>
                <img src="/atAmazonOfficeThree.jpeg" width={"auto"} height={300} alt="At the AWS office"
                     style={{margin: 5}}/>
                <img src="/atAmazonOfficeTwo.jpeg" width={"auto"} height={300} alt="At the AWS office"
                     style={{margin: 5}}/>
                {
                    Array.from({length: 10}, (_, i) => i + 2).map((num) => (
                        <img key={num} src={"/t" + num + ".jpg"} width={"auto"} height={300} alt="" style={{margin: 5}}/>
                    ))
                }
                <div>
                    <h4 style={{textAlign: "left"}}>
                        About Us: Redefining Digital Equity
                    </h4>
                    <h4 style={{textAlign: "left"}}>
                        Our Mission
                    </h4>
                    <b>
                        "Empowering the next generation by harmonizing technical hardware mastery with
                        neuroscience-driven digital literacy to build a sustainable, healthy, and waste-free digital
                        future."
                    </b>
                </div>
                <hr/>
                <div>
                    <h4 style={{textAlign: "left"}}>
                        The Synergy of Hardware and Software: Meet the Founders
                    </h4>
                    Founded in September 2023 by Yijoon Kim and Antonio Valles Miles during their Freshman year at
                    Singapore American School (SAS), Computers for Students (CFS) is an independent non-profit
                    organization established outside of school.
                    <h4 style={{textAlign: "left"}}>
                        Motivation & Vision
                    </h4>
                    We identified a systemic gap where functional corporate technology was discarded as e-waste while
                    students in developing regions lacked digital access. To bridge this divide, we established a
                    "Circular Tech Economy" model that repurposes unused corporate laptops into lifelong educational
                    assets, harmonizing environmental sustainability with neuroscience-based literacy training.
                    <h4 style={{textAlign: "left"}}>
                        Strategic Partnership (AWS Southeast Asia)
                    </h4>
                    To fuel this vision, we orchestrated a sustainable supply chain in collaboration with AWS Southeast
                    Asia. Through this partnership, we secure donations of unused corporate laptops from AWS employees,
                    turning a corporate waste challenge into a global educational opportunity.
                </div>
                <hr/>
                <div>
                    <h4 style={{textAlign: "left"}}>
                        Yijoon Kim: Digital & Research Strategist
                    </h4>
                    <h4 style={{textAlign: "left"}}>
                        Yijoon leads the technical architecture and the educational frontier of CFS.
                    </h4>
                    <ul>
                        <li>
                            Digital Infrastructure: He independently developed and architected the organization’s
                            official web application (computersforstudents.org) and integrated blog platform from
                            scratch without templates, engineering a custom system to manage global outreach and ensure
                            project transparency.
                        </li>
                        <li>
                            Comprehensive Educational Curriculum: Leveraging his neuroscience research, Yijoon designed
                            the Digital Mental Health curriculum to educate students on the brain’s neurological
                            response to digital overconsumption. He also delivers lectures on Digital Literacy & Ethics,
                            including AI Ethics (responsible use of ChatGPT), plagiarism prevention, and internet
                            safety.
                        </li>
                    </ul>
                    <h4 style={{textAlign: "left"}}>
                        Antonio Valles Miles: Hardware & Logistical Architect
                    </h4>
                    <h4 style={{textAlign: "left"}}>
                        Antonio serves as the technical lead for physical operations and hardware optimization.
                    </h4>
                    <ul>
                        <li>
                            Hardware Revival: He oversees the entire hardware diagnostic pipeline, transforming unused
                            corporate inventory into high-performance educational machines.
                        </li>
                        <li>
                            Logistics & Strategy: Antonio manages the complex "last-mile" logistics to remote regions
                            and optimizes device configurations to perform reliably in low-connectivity environments,
                            ensuring every laptop remains a functional tool regardless of local infrastructure
                            challenges.
                        </li>
                    </ul>
                </div>
                <hr/>
                <div>
                    <h4 style={{textAlign: "left"}}>
                        What We Do: Our Core Pillars
                    </h4>
                    <h4 style={{textAlign: "left"}}>
                        At CFS, we don't just donate hardware; we build a sustainable ecosystem where technology and
                        education meet.
                    </h4>
                    <ul>
                        <li>
                            Sustainability & Repair Culture (Joint Initiative): We champion a "Repair, Don't Replace"
                            philosophy. Both founders lead hands-on workshops where students learn to disassemble and
                            troubleshoot internal components like the CPU, RAM, and Storage. This fosters technical
                            self-sufficiency and directly reduces local e-waste.
                        </li>
                        <li>
                            Digital Literacy & Cognitive Well-being: We empower students to navigate the digital
                            landscape safely. By integrating neuroscience, we teach the importance of digital mental
                            health alongside technical skills like data privacy and critical thinking.
                        </li>
                        <li>
                            Strategic Donation & Long-term Support: At the end of our missions, we donate laptops along
                            with essential repair toolkits and customized manuals. We also provide spare parts to ensure
                            the technology remains usable for years to come.
                        </li>
                        <li>
                            Economic & Educational Impact: Our initiatives save schools significant costs, allowing them
                            to redirect budgets toward enhancing education quality while our devices serve as lifelong
                            windows to global information.
                        </li>
                    </ul>
                </div>
                <hr/>
                <div>
                    <b>
                        Our Proven Impact (As of June 2026):
                    </b>
                    <ul>
                        <li>
                            <b>264 Laptops Donated (Powered by AWS Southeast Asia & Partners)</b>
                        </li>
                        <li>
                            <b>415+ Students, Faculty, and Officials Reached</b>
                        </li>
                        <li>
                            <b>
                                2,000 Trees Planted through environmental restoration initiatives, including the UNESCO
                                Can Gio Mangrove, in collaboration with AWS Southeast Asia and local community partners
                                to help offset our carbon footprint.
                            </b>
                        </li>
                    </ul>
                </div>
                <hr/>
                <div>
                    <h4 style={{textAlign: "left"}}>
                        Contact Us:
                    </h4>
                    For donations or general inquiries, please reach out to us at the email below:
                    <br/>
                    info@computersforstudents.org
                </div>
                {/*<p>
                    <br/>
                    <br/>
                    Yijoon Kim and Antonio Valles Miles founded Computers for Students in August of 2023, with the aim
                    of nurturing a new generation of individuals prepared for the digital world.
                    <br/>
                    <br/>
                    Central to our approach is the promotion of digital literacy. This initiative goes beyond technical
                    skills to encompass a deep understanding of how to effectively utilize and engage with digital
                    technologies. By imparting knowledge on topics such as internet safety, data privacy, and critical
                    thinking in the digital realm, we aim to equip students with the tools necessary to navigate and
                    thrive in the increasingly interconnected digital world.
                    <br/>
                    <br/>
                    Moreover, our commitment is to equip the next generation with the skills to diagnose and repair
                    electronic devices. It's not just about fixing gadgets; it's about addressing the urgent problem of
                    e-waste.
                    <br/>
                    <br/>
                    In today's fast-paced world, electronic waste is a pressing issue. Computers for Students hopes to
                    address this by empowering students with technical skills while also fostering a sense of
                    responsibility and environmental awareness.
                    <br/>
                    <br/>
                    We hope to conduct in-person teaching sessions, providing hands-on experiences. These students will
                    use their knowledge to independently maintain the electronic products we donate, thus reducing
                    environmental waste.
                </p>*/}
            </div>
        </section>
    );
}

export default About;
